import NcBookmark, {NcBookmarkProps} from "components/NcBookmark/NcBookmark";
import React from "react";
import {useAppSelector, useAppDispatch} from "app/hooks";
import {
  addNewSavedByPostId,
  removeSavedByPostId,
  selectRecentSaveds,
  selectRecentRemoveds,
} from "app/bookmarks/bookmarksSlice";
import {deleteDoc, doc, increment, serverTimestamp, setDoc, updateDoc} from "firebase/firestore";
import {auth, db} from "../../configs/firebase-config";
import {displayToast, toastType} from "../../global/Functions";

export type BookmarkContainerProps = Omit<NcBookmarkProps, "isBookmarked"> & {
  initBookmarked: boolean;
  data?: any;
};

const BookmarkContainer: React.FC<BookmarkContainerProps> = (props) => {
  const {postId, initBookmarked} = props;
  const recentSaveds = useAppSelector(selectRecentSaveds);
  const recentRemoveds = useAppSelector(selectRecentRemoveds);
  const dispatch = useAppDispatch();

  const bookmarkDocRef = doc(db, "bookmarks", `${auth.currentUser?.uid}/posts/${postId}`);
  const postDocRef = doc(db, "posts", `${props.data?.userId}/posts/${postId}`);
  const isBookmarked = () => {
    if (recentSaveds.includes(postId)) {
      return true;
    }
    return initBookmarked && !recentRemoveds.includes(postId);
  };

  const handleClickBookmark = async () => {
    if (isBookmarked()) {
      if (auth.currentUser?.uid) {
        await deleteDoc(bookmarkDocRef);
      } else {
        displayToast("Log in to bookmark this post", toastType.info);
        return;
      }
      // await updateDoc(postDocRef, {priority: increment(15)});
      dispatch(removeSavedByPostId(postId));
    } else {
      if (auth.currentUser?.uid) {
        await setDoc(bookmarkDocRef, {postId, userId: auth.currentUser.uid, savedAt: serverTimestamp()});
      }else {
        displayToast("Log in to bookmark this post", toastType.info);
        return;
      }
      // await updateDoc(postDocRef, { priority: increment(15)});
      dispatch(addNewSavedByPostId(postId));
    }
  };

  return (
    <NcBookmark
      onClick={handleClickBookmark}
      isBookmarked={isBookmarked()}
      {...props}
    />
  );
};

export default BookmarkContainer;
